module.exports = __webpack_public_path__ + "static/media/1POLICY32.3e9563a7.jpg";